import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { ADMISION } from './Styles/StylesAdmision';
import logo from "../../assets/img/logo_menu_black.png";


let hoy = new Date();
let dd = hoy.getDate();
let mm = hoy.getMonth()+1;
let yyyy = hoy.getFullYear();
if(dd < 10) dd= '0' + dd;
if(mm < 10) mm= '0' + mm;
let qrCode = "";

class PlanillaAdmision extends Component {

    requisitos = () => {
        const styles = StyleSheet.create(ADMISION[0]);
        let { requisitos, requisitosCon } = this.props;

        let marca = (opcion) => {
            let texto = "( )";
            if (requisitosCon.includes(opcion) === true) texto = "(X)"
            return texto
        }
        
        return(
            requisitos.map(option => (
                <View key={option.id} style={[styles.row]}>
                    <Text style={[styles.col7, styles.font7, styles.bordeCol7, styles.center]}>{marca(option.id)}</Text>
                    <Text style={[styles.col8, styles.font6, styles.bordeCol8]}>{option.requisito_desc}</Text>
                </View>
            ))
        )
    }

    fecha = (fecha) => {
        let hoy = new Date(fecha);
        let dd = hoy.getDate();
        let mm = hoy.getMonth()+1;
        let yyyy = hoy.getFullYear();
        if(dd < 10) dd= '0' + dd;
        if(mm < 10) mm= '0' + mm;
        return `${dd}/${mm}/${yyyy}`
    }

    contenidoInsc = (tipo) => {
        const stylesAdm = StyleSheet.create(ADMISION[0]);
        let { data, dataInscripcion, tipoInsc, periodo2, dataEst, creditos, monto, inscripcion, cuotaN, cuotas, qr } = this.props;

        let dato = (dat) => {
            let str = dat;
            if (dat === null) str = "";
            return str;
        }

        let materiasInsc = () => {
            if (data === "") return (
                <View style={[stylesAdm.row]}>
                    <Text style={[stylesAdm.colTabla10, stylesAdm.font8, stylesAdm.bordeCol11, stylesAdm.center]}>
                        No has inscrito ninguna materia    
                    </Text>
                </View>
            )
            
            if (data.length === 0) return (
                <View style={[stylesAdm.row]}>
                    <Text style={[stylesAdm.colTabla10, stylesAdm.font8, stylesAdm.bordeCol11, stylesAdm.center]}>
                        No has inscrito ninguna materia    
                    </Text>
                </View>
            )

            return (
                data.map(option => (
                    <View key={option[0]} style={[stylesAdm.row]}>
                        <Text style={[stylesAdm.colTabla1, stylesAdm.font8, stylesAdm.bordeCol11]}>{option[1].materia}</Text>
                        <Text style={[stylesAdm.colTabla2, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{option[1].seccion}</Text>
                        <Text style={[stylesAdm.colTabla3, stylesAdm.font6, stylesAdm.bordeCol9, stylesAdm.center]}>{option[1].tipoM.label}</Text>
                        <Text style={[stylesAdm.colTabla3, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{option[4].label}</Text>
                        <Text style={[stylesAdm.colTabla4, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{option[2]}</Text>
                        <Text style={[stylesAdm.colTabla3, stylesAdm.font8, stylesAdm.bordeCol9, stylesAdm.center]}>{`${option[3]} Bs.`}</Text>
                    </View>
                ))
            )
        }

        let itemsFactura = (num, item, monto) => (
            <View style={[stylesAdm.row]}>
                <Text style={[stylesAdm.colTabla6, stylesAdm.font8, stylesAdm.bordeCol11, stylesAdm.center]}>{num}</Text>
                <Text style={[stylesAdm.colTabla7, stylesAdm.font8, stylesAdm.bordeCol11]}>{item}</Text>
                <Text style={[stylesAdm.colTabla8, stylesAdm.font8, stylesAdm.bordeCol11, stylesAdm.center]}>{monto}</Text>
            </View>
        )

        return (
            <React.Fragment>
                <View style={stylesAdm.row}>
                    <Image
                        style={[stylesAdm.colContent40, stylesAdm.logo]}
                        src={logo}
                    />
                    <View style={[stylesAdm.colContent60, stylesAdm.header1Left,{marginTop: 14,}]}>
                        <Text style={[stylesAdm.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[stylesAdm.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                    <Text style={[stylesAdm.token]}>N° - {(dataInscripcion.token).substring(0,10)}</Text>
                </View>
                <Text style={[stylesAdm.titulo, stylesAdm.header1Right, stylesAdm.custonMt10, stylesAdm.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    PLANILLA DE {tipoInsc}
                </Text>
                <View style={[stylesAdm.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>I. DETALLES DE LA SOLICITUD</Text>
                    <View style={[stylesAdm.row, {padding: 5, backgroundColor: "#fff"}]}>
                        <View style={[stylesAdm.col6]}>
                            <View style={[stylesAdm.row]}>
                                <Text style={[stylesAdm.col3, stylesAdm.font10]}>Periodo Académico: {periodo2.toUpperCase()}</Text>
                                <Text style={[stylesAdm.col3, stylesAdm.font10, {textAlign: "right"}]}>Carrera: {dataEst.carrera}</Text>
                            </View>
                            <View style={[stylesAdm.row]}>
                                <Text style={[stylesAdm.col3, stylesAdm.font10]}>Fecha de la solicitud: {dataInscripcion.solicitud}</Text>
                                <Text style={[stylesAdm.col3, stylesAdm.font10, {textAlign: "right", color: "#c60000"}]}>Debes asistir a formalizar tu inscripción el dia: {dataInscripcion.cita}</Text>
                            </View>
                            <View style={[stylesAdm.row, {marginTop: 5}]}>
                                {/* <Text style={[stylesAdm.col6, stylesAdm.font6, {textAlign: "justify"}]}>
                                    Importante: Si no asistes en la fecha pautada, tu solicitud de inscripción será rechazada automáticamente por el sistema y deberás realizar el proceso nuevamente
                                </Text> */}
                                <Text style={[stylesAdm.col6, stylesAdm.font8, {textAlign: "justify", color: "#c60000"}]}>
                                    Importante: Debido a la cuarentena, no es necesario que acudas a la institución el dia de la cita pero si debes cancelar los aranceles antes de esa fecha
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[stylesAdm.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>II. DATOS DEL ESTUDIANTE</Text>
                    <View style={[{padding: 5, backgroundColor: "#fff"}]}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.col2, stylesAdm.font9]}>Cédula de Identidad: {`${dataEst.nacionalidad} ${dataEst.cedula}`}</Text>
                            <Text style={[stylesAdm.col4, stylesAdm.font9, {textAlign: "right"}]}>Nombres y Apellidos: {`${dataEst.nombre1} ${dato(dataEst.nombre2)} ${dataEst.apellido1} ${dato(dataEst.apellido2)}`}</Text>
                        </View>
                    </View>
                </View>
                <View style={[stylesAdm.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>III. DETALLES DE LA INSCRIPCIÓN</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla1, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF"}]}>Materia</Text>
                            <Text style={[stylesAdm.colTabla2, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Sección</Text>
                            <Text style={[stylesAdm.colTabla3, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Modalidad</Text>
                            <Text style={[stylesAdm.colTabla3, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Semestre</Text>
                            <Text style={[stylesAdm.colTabla4, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>U.C.</Text>
                            <Text style={[stylesAdm.colTabla3, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Monto</Text>
                        </View>
                        {materiasInsc()}
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla5, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF", textAlign: 'right'}]}>Totales</Text>
                            <Text style={[stylesAdm.colTabla4, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>{creditos}</Text>
                            <Text style={[stylesAdm.colTabla3, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>{monto} Bs.</Text>
                        </View>
                        <View style={[stylesAdm.row, {paddingRight: 5, marginTop: 3}]}>
                            <Text style={[stylesAdm.font7, {color: "#c60000"}]}>IMPORTANTE: El Total en Bs. de las materias corresponde al valor actual de la Unidad de Crédito por lo que puede variar en cada cuota. El monto es solo referencial</Text>
                        </View>
                    </View>
                    <Text style={[stylesAdm.font10, {marginTop: 10, backgroundColor: "#ccc"}]}>IV. DETALLES DE FACTURACIÓN</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff",}]}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla6, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF", textAlign: 'center'}]}>N°</Text>
                            <Text style={[stylesAdm.colTabla7, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF"}]}>Descripción</Text>
                            <Text style={[stylesAdm.colTabla8, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>Precio</Text>
                        </View>
                        {itemsFactura(1, tipoInsc, inscripcion)}
                        {itemsFactura(2, cuotaN, `${(monto/* /cuotas */)} Bs.`)}
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.colTabla9, stylesAdm.font9, stylesAdm.bordeCol11, stylesAdm.borderTop, {backgroundColor: "#777", color:"#FFF", textAlign: 'right'}]}>TOTAL A PAGAR</Text>
                            <Text style={[stylesAdm.colTabla8, stylesAdm.font9, stylesAdm.bordeCol9, stylesAdm.borderTop, stylesAdm.center, {backgroundColor: "#777", color:"#FFF"}]}>{parseFloat(inscripcion.replace(' Bs.', '')) + (monto)} Bs.</Text>
                        </View>
                    </View>
                </View>
                <View style={[stylesAdm.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                    <Text style={[stylesAdm.font10, {backgroundColor: "#ccc"}]}>V. PARA SER LLENADO EN LA INSTITUCIÓN</Text>
                    <View style={{padding: 5, backgroundColor: "#fff"}}>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.col3, stylesAdm.font7, stylesAdm.bordeCol11, stylesAdm.borderTop, {borderBottom: 0}]}>OBSERVACIONES:</Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.borderTop, {borderBottom: 0}]}>ADMINISTRACION</Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.borderTop, {borderBottom: 0}]}>CTROL. DE ESTUDIOS</Text>
                        </View>
                        <View style={[stylesAdm.row]}>
                            <Text style={[stylesAdm.col3, stylesAdm.font7, stylesAdm.bordeCol11, {height: 70}]}></Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.center, {height: 70, paddingTop: 25}]}>FIRMA Y SELLO</Text>
                            <Text style={[stylesAdm.col1, stylesAdm.font7, stylesAdm.bordeCol9, stylesAdm.center, {height: 70, paddingTop: 25}]}>FIRMA Y SELLO</Text>
                        </View>
                    </View>
                </View>

                <View style={stylesAdm.row}>
                    <Text style={[stylesAdm.tipo, {textAlign: "right", marginTop: 10}]}>{tipo}</Text>
                </View>

                <View style={[stylesAdm.footer2]}>
                    <View style={[stylesAdm.row]}>
                        <View style={[stylesAdm.col9]}>
                            <Text style={[stylesAdm.encabezado, {fontSize: 6, textAlign: "center"}]}>
                                Esta planilla debe ser impresa en Papel Bond Blanco tamaño Carta | Para autenticar este registro vaya al enlace: https://iudlm.com/validar y coloque el número de la planilla. También puedes escanear el código qr de la derecha.
                            </Text>
                            <Text style={[stylesAdm.linea2]}></Text>
                            <Text style={[stylesAdm.encabezado]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[stylesAdm.encabezado, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                        <View style={[stylesAdm.col10]}>
                            <Image
                                style={[stylesAdm.logoQr, {left:20}]}
                                src={qr}
                            />
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }

    render() {
        const styles = StyleSheet.create(ADMISION[0]);
        let { datos, periodo, carrera, token, fecha, cita, qrCode } = this.props;

        let dato = (dat) => {
            let str = dat;
            if (dat === null) str = "";
            return str;
        }
        
        return (
            <PDFViewer style={styles.section}>
                <Document title="Planilla de Admisión">
                    <Page size="letter" style={styles.body}>
                        <View style={styles.row}>
                            <Image
                                style={[styles.colContent40, styles.logo]}
                                src={logo}
                            />
                            <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                                <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                                <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                            </View>
                            <Text style={[styles.token]}>N° - {token.substring(0,10)}</Text>
                        </View>
                        <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                            {fontSize: 16, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                            SOLICITUD DE ADMISIÓN
                        </Text>
                        
                        <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                            <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DETALLES DE LA SOLICITUD</Text>
                            <View style={[styles.row, {padding: 5, backgroundColor: "#fff"}]}>
                                <View style={[styles.col6]}>
                                    <View style={[styles.row]}>
                                        <Text style={[styles.col3, styles.font10]}>Periodo Académico: {periodo.label}</Text>
                                        <Text style={[styles.col3, styles.font10, {textAlign: "right"}]}>Carrera: {carrera.label2}</Text>
                                    </View>
                                    <View style={[styles.row]}>
                                        <Text style={[styles.col3, styles.font10]}>Fecha de la solicitud: {fecha}</Text>
                                        <Text style={[styles.col3, styles.font10, {textAlign: "right", color: "#c60000"}]}>Debes asistir con la documentación el dia: {cita}</Text>
                                    </View>
                                    <View style={[styles.row, {marginTop: 5}]}>
                                        {/* <Text style={[styles.col6, styles.font6, {textAlign: "justify"}]}>
                                        Importante: Si no asistes en la fecha pautada, tu solicitud de admisión será rechazada automáticamente por el sistema y deberás realizar el proceso nuevamente
                                        </Text> */}
                                        <Text style={[styles.col6, styles.font8, {textAlign: "justify", color: "#c60000"}]}>
                                            Importante: Debido a la cuarentena, no es necesario que acudas a la institución el dia de la cita pero si debes cancelar los aranceles antes de esa fecha
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                            <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. DATOS PERSONALES</Text>
                            <View style={[{padding: 5, backgroundColor: "#fff"}]}>
                                <View style={[styles.row]}>
                                    <Text style={[styles.col2, styles.font10]}>Cédula de Identidad: {`${datos.selectNac.label} ${datos.cedula.text}`}</Text>
                                </View>
                                <View style={[styles.row]}>
                                    <Text style={[styles.col6, styles.font10]}>Nombres y Apellidos: {`${datos.nombre1.text} ${dato(datos.nombre2.text)} ${datos.apellido1.text} ${dato(datos.apellido2.text)}`}</Text>
                                </View>
                            </View>

                            <Text style={[styles.font10, {marginTop: 5, backgroundColor: "#ccc",}]}>III. DATOS DE NACIMIENTO</Text>
                            <View style={[{padding: 5, backgroundColor: "#fff"}]}>
                                <View style={[styles.row]}>
                                    <Text style={[styles.col1, styles.font10]}>Pais: {datos.selectPais.label}</Text>
                                    <Text style={[styles.col1, styles.font10]}>Estado: {datos.selectEstado.label}</Text>
                                    <Text style={[styles.col3, styles.font10]}>Municipio: {datos.selectMunicipio.label}</Text>
                                </View>
                                <View style={[styles.row]}>
                                    <Text style={[styles.col4, styles.font10]}>Parroquia: {datos.selectParroquia.label}</Text>
                                    <Text style={[styles.col2, styles.font10, {textAlign:"right"}]}>Fecha de Nacimiento: {this.fecha(datos.fecha)}</Text>
                                </View>
                            </View>
                            <Text style={[styles.font10, {marginTop: 5, backgroundColor: "#ccc",}]}>IV. DIRECCIÓN DE HABITACIÓN</Text>
                            <View style={[{padding: 5, backgroundColor: "#fff"}]}>
                                <View style={[styles.row]}>
                                    <Text style={[styles.col3, styles.font10]}>Municipio: {datos.selectMunicipioDir.label}</Text>
                                    <Text style={[styles.col3, styles.font10]}>Parroquia: {datos.selectParroquiaDir.label}</Text>
                                </View>
                                <View style={[styles.row]}>
                                    <Text style={[styles.col3, styles.font10]}>Av/Calle/Sector: {datos.calle.text}</Text>
                                    <Text style={[styles.col3, styles.font10]}>Edf/Casa/Quinta: {datos.casa.text}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                            <View style={[{backgroundColor: "#fff"}]}>
                                <Text style={[styles.font10, {backgroundColor: "#ccc",}]}>V. DOCUMENTOS A CONSIGNAR</Text>
                                <Text style={[styles.col6, styles.font7, {paddingTop: 5, paddingBottom: 5,}]}>
                                    A continuación la lista de documentos consignados (marcados con una X)
                                </Text>
                                <View style={[{paddingLeft: 5}]}>
                                    {this.requisitos()}
                                </View>
                            </View>
                        </View>
                        <View style={[styles.footer]}>
                            <View style={[styles.row]}>
                                <View style={[styles.col9]}>
                                    <Text style={[styles.encabezado, {fontSize: 6, textAlign: "center"}]}>
                                        Esta planilla debe ser impresa en Papel Bond Blanco tamaño Carta | Para autenticar este registro vaya al enlace: https://iudlm.com/validar y coloque el número de la planilla. También puedes escanear el código qr de la derecha.
                                    </Text>
                                    <Text style={[styles.linea2]}></Text>
                                    <Text style={[styles.encabezado]}>
                                        Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                        C.P.1061  Edo Miranda - Caracas - Venezuela
                                    </Text>
                                    <Text style={[styles.encabezado, {marginTop: -5}]}>
                                        Telefax: +58 212 9930983 | 9939139 | 9910710.
                                    </Text>
                                </View>
                                <View style={[styles.col10]}>
                                    <Image
                                        style={[styles.logoQr, {left:40}]}
                                        src={qrCode}
                                    />
                                </View>
                            </View>
                        </View>
                    </Page>
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenidoInsc("ORIGINAL - INSTITUTO")}
                        </View>
                    </Page>
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenidoInsc("COPIA - ESTUDIANTE")}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default PlanillaAdmision;


// WEBPACK FOOTER //
// ./src/components/Reportes/PlanillaAdmision.jsx